import React, { useState } from "react";
import DataGrid from "../../UX/DataGrid/DataGrid";
import { GridColumn } from "@progress/kendo-react-grid";
import DataGridPercentInputCell from "../../UX/DataGridCells/DataGridPercentInputCell/DataGridPercentInputCell";
import SmallButton from "../../UX/SmallButton/SmallButton";
import NumericalTextBox from "../../UX/NumericalTextBox/NumericalTextBox";
import "./MarginalTaxBrackets.scss";
import SelfClearingNumericTextBox from "../../UX/DataGridCells/SelfClearingNumericTextBox/SelfClearingNumericTextBox";
import { isNumericTextboxValid } from "../../Utilities/validation";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmationDialog from "../../UX/ConfirmationDialog/ConfirmationDialog";
import { NumericTextBox } from "@progress/kendo-react-inputs";

const MarginalTaxBracketsDeleteCommandCell = (deleteFunction) => {
  const [state, setState] = useState({
    showDeleteConfirm: false,
    dataItem: null,
  });

  return (props) => {
    const dataItem = props.dataItem;

    if (dataItem.inEdit && !dataItem.isFirst) {
      return (
        <React.Fragment>
          <td className={"instream-datagrid-command-cell"}>
            <a
              className={"command-delete"}
              href={"javascript:void(0);"}
              onClick={() => {
                setState({
                  showDeleteConfirm: true,
                  dataItem: dataItem,
                });
              }}
            >
              <DeleteIcon />
            </a>
          </td>
          {state.showDeleteConfirm &&
            state.dataItem !== null &&
            state.dataItem.editIndex === dataItem.editIndex && (
              <ConfirmationDialog
                title={"Confirmation"}
                message={"Are you sure you want to delete this tax bracket?"}
                cancelLabel={"cancel"}
                confirmLabel={"delete"}
                onConfirm={() => {
                  setState({
                    showDeleteConfirm: false,
                  });
                  deleteFunction(state.dataItem);
                }}
                onCancel={() =>
                  setState({
                    showDeleteConfirm: false,
                  })
                }
              />
            )}
        </React.Fragment>
      );
    }

    return <td>&nbsp;</td>;
  };
};

const MarginalTaxBracketsDataGridCurrencyCell = (props) => {
  const onChange = (e) => {
    props.onChange({
      dataItem: props.dataItem,
      field: props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value,
    });
  };

  const { dataItem, field } = props;
  const dataValue = dataItem[field] === null ? "" : dataItem[field];
  const cellClass = dataItem.inEdit ? "edit-mode" : "read-mode";

  const isValid = dataItem.invalidFields
    ? !dataItem.invalidFields.includes(field)
    : true;

  let cell;
  if (!dataItem.isLast) {
    cell = (
      <NumericTextBox
        label={""}
        disabled={!dataItem.inEdit}
        value={dataValue}
        format={"c2"}
        min={0}
        max={1000000000}
        onChange={onChange}
        onBlur={onChange}
        valid={dataValue >= 0 && dataValue <= 1000000000 && isValid}
      />
    );
  }

  return (
    <td className={`instream-datagrid-currency-cell ${cellClass}`}>{cell}</td>
  );
};

const MarginalTaxBrackets = (props) => {
  const deleteCommandCell = MarginalTaxBracketsDeleteCommandCell(
    props.reducer.deleteTaxBracket
  );

  let addTaxBracketButton;
  if (props.inEdit && !props.isStatic) {
    addTaxBracketButton = (
      <SmallButton
        label={"Add Tax Bracket"}
        outline={true}
        icon={"plus"}
        onChange={props.reducer.addTaxBracket}
      />
    );
  }

  return (
    <div className={"instream-marginal-tax-brackets"}>
      <div className={"instream-marginal-tax-brackets-controls"}>
        {/*<NumericalTextBox*/}
        {/*  value={props.inflationRate}*/}
        {/*  min={0}*/}
        {/*  max={1}*/}
        {/*  step={0.01}*/}
        {/*  format="0.00%"*/}
        {/*  label={"Inflation Rate"}*/}
        {/*  disabled={!props.inEdit}*/}
        {/*  update={props.reducer.onInflationRateChange}*/}
        {/*  valid={isNumericTextboxValid(props.inflationRate, 0, 1)}*/}
        {/*/>*/}
        {addTaxBracketButton}
      </div>
      <DataGrid
        data={props.data}
        className={"instream-marginal-tax-brackets-data-grid"}
        noBorder={true}
        hidePager={true}
        onItemChange={props.reducer.updateTaxBracket}
      >
        <GridColumn
          field={"taxRate"}
          title={"Tax Rate"}
          cell={DataGridPercentInputCell}
        />
        <GridColumn
          field={"startAmount"}
          title={"Start Amount"}
          editable={false}
          format={"{0:C}"}
        />
        {!props.isStatic && <GridColumn
          field={"endAmount"}
          title={"End Amount"}
          cell={MarginalTaxBracketsDataGridCurrencyCell}
        />}
        {props.isStatic && <GridColumn
            field={"endAmount"}
            title={"End Amount"}
            editable={false}
            format={"{0:C}"}
        />}
        {!props.isStatic && <GridColumn cell={deleteCommandCell} />}
      </DataGrid>
    </div>
  );
};

export default MarginalTaxBrackets;
